// Lazy loaded in component - no static imports needed

import { useNavigate } from 'react-router-dom';
import { useExports } from './useExports';
import { salesExportColumns } from '../data/exportData';

export const useSalesExport = () => {
  const navigate = useNavigate();

  const handleExit = () => {
    navigate('/salesInvoiceReport');
  };

  const exportHook = useExports({
    columns: salesExportColumns,
    action: 'SALESEXPORT',
  });

  return {
    ...exportHook,
    handleExit,
  };
};
